/**
 * Guest token storage utilities
 * Handles storing and retrieving guest session tokens
 */

const GUEST_TOKEN_KEY = "guest_token";
const PENDING_INVITATION_KEY = "pending_invitation";

export function setGuestToken(token: string): void {
  localStorage.setItem(GUEST_TOKEN_KEY, token);
}

export function getGuestToken(): string | null {
  return localStorage.getItem(GUEST_TOKEN_KEY);
}

export function removeGuestToken(): void {
  localStorage.removeItem(GUEST_TOKEN_KEY);
}

export function setPendingInvitation(code: string): void {
  sessionStorage.setItem(PENDING_INVITATION_KEY, code);
}

export function getPendingInvitation(): string | null {
  return sessionStorage.getItem(PENDING_INVITATION_KEY);
}

export function removePendingInvitation(): void {
  sessionStorage.removeItem(PENDING_INVITATION_KEY);
}
